import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
export function PrivacyPolicyPage() {
  return <>
      <Helmet data-id="element-9360" data-mp="2mukacr8a0zi7">
        <title data-id="element-9361" data-mp="2mt0tozipkmfw">Privacy Policy | ToxicDetector</title>
        <meta name="description" content="Learn how ToxicDetector protects your data and privacy when analyzing messages for toxicity and manipulation." data-id="element-9362" data-mp="2mweysfirb9r1" />
        <link rel="canonical" href="https://toxicdetector.com/privacy" data-id="element-9363" data-mp="2dznq93n0q2fk" />
        <meta property="og:title" content="Privacy Policy | ToxicDetector" data-id="element-9364" data-mp="2it8rr5ntleji" />
        <meta property="og:description" content="Learn how ToxicDetector protects your data and privacy when analyzing messages for toxicity and manipulation." data-id="element-9365" data-mp="244ccanjfoz8v" />
        <meta property="og:url" content="https://toxicdetector.com/privacy" data-id="element-9366" data-mp="1v2cuht0lhr4v" />
        <meta property="og:type" content="website" data-id="element-9367" data-mp="1z4ggvcosyg4x" />
        <meta name="robots" content="index, follow" data-id="element-9368" data-mp="1z36jkpprxbzc" />
      </Helmet>
      <div className="flex flex-col w-full min-h-screen bg-[#f8f6f2]" data-id="element-9369" data-mp="29r3jinc3c408">
        <header className="bg-white border-b border-gray-200" data-id="element-9370" data-mp="24sjyqq98gy9g">
          <div className="max-w-4xl mx-auto px-5 py-4" data-id="element-9371" data-mp="24s0eh2w41xs9">
            <Link to="/" className="inline-flex items-center text-gray-600 hover:text-purple-600 text-sm mb-2" data-id="element-9372" data-mp="2jqcd3f31ngm2">
              <ArrowLeft size={16} className="mr-1" data-id="element-9373" data-mp="2erhmvs2qyprx" />
              Back to Home
            </Link>
            <h1 className="text-2xl font-bold" data-id="element-9374" data-mp="1r1exjjq7vxx0">Privacy Policy</h1>
            <p className="text-gray-600 text-sm mt-1" data-id="element-9375" data-mp="1m33jewsw318z">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
            </p>
          </div>
        </header>

        <div className="max-w-4xl mx-auto w-full px-5 py-8" data-id="element-9376" data-mp="189cl6kklz3sk">
          <div className="bg-white rounded-xl p-8 shadow-sm" data-id="element-9377" data-mp="13bsugl6q4yjq">
            <section className="mb-8" data-id="element-9378" data-mp="13batxcd13y60">
              <h2 className="text-xl font-bold mb-4" data-id="element-9379" data-mp="1t083hg94947y">Introduction</h2>
              <p className="text-gray-700 mb-4" data-id="element-9380" data-mp="1sxvnv9qtz5y2">
                Welcome to ToxicDetector ("we," "our," or "us"). We are
                committed to protecting your privacy and ensuring the security
                of your personal information. This Privacy Policy explains how
                we collect, use, disclose, and safeguard your information when
                you use our web application and services.
              </p>
              <p className="text-gray-700" data-id="element-9381" data-mp="1e1w77apnnxhb">
                By using ToxicDetector, you agree to the collection and use of
                information in accordance with this Privacy Policy. If you do
                not agree with our policies and practices, please do not use our
                services.
              </p>
            </section>

            <section className="mb-8" data-id="element-9382" data-mp="2ugfnvz2f05h0">
              <h2 className="text-xl font-bold mb-4" data-id="element-9383" data-mp="2zfihmncy2p9o">
                1. Information We Collect
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9384" data-mp="nsopd09fw3o3">
                1.1 Information You Provide
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-9385" data-mp="iun5id46w0bk">
                We collect information that you voluntarily provide when using
                our services:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9386" data-mp="94aqf0f58zct">
                <li data-id="element-9387" data-mp="51xh6216ujba">
                  <strong data-id="element-9388" data-mp="527bg1t9ncms">Account Information:</strong> Name, email address,
                  password (encrypted), and profile details
                </li>
                <li data-id="element-9389" data-mp="4xbhs893ikp">
                  <strong data-id="element-9390" data-mp="3r8vsn5nxzywc">Uploaded Content:</strong> Screenshots and images of
                  text conversations you upload for analysis
                </li>
                <li data-id="element-9391" data-mp="3mbvnqy2tx26t">
                  <strong data-id="element-9392" data-mp="3mcf78j84nymy">Analysis Data:</strong> Results from toxicity
                  analysis, including detected patterns and risk scores
                </li>
                <li data-id="element-9393" data-mp="1kjz9hgpa1e8c">
                  <strong data-id="element-9394" data-mp="1kgl8ocw9hd30">Communication Preferences:</strong> Settings for
                  notifications, marketing emails, and data sharing preferences
                </li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9395" data-mp="1xhozq16g38vc">
                1.2 Automatically Collected Information
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-9396" data-mp="1nk0u2g7awgye">
                When you access our services, we automatically collect certain
                information:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9397" data-mp="19qt2upn4tnh8">
                <li data-id="element-9398" data-mp="1el5o958658vm">
                  <strong data-id="element-9399" data-mp="1elp7qqdgw5br">Usage Data:</strong> Pages visited, features used,
                  time spent on the platform, and interaction patterns
                </li>
                <li data-id="element-9400" data-mp="14uktxtzj2qii">
                  <strong data-id="element-9401" data-mp="14u2ms2bburvt">Device Information:</strong> Browser type, operating
                  system, device identifiers, and IP address
                </li>
                <li data-id="element-9402" data-mp="uvv9puk5stz3">
                  <strong data-id="element-9403" data-mp="uv3o9cka0cmj">Authentication Data:</strong> Login timestamps,
                  session information, and security events
                </li>
                <li data-id="element-9404" data-mp="78hv0uos2ae8">
                  <strong data-id="element-9405" data-mp="7903qqsmmh31">Analytics Data:</strong> Aggregated usage statistics
                  and performance metrics
                </li>
              </ul>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9406" data-mp="l5n0otkkx78y">
                1.3 Cookies and Tracking Technologies
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-9407" data-mp="v5nooste8bjh">
                We use cookies and similar tracking technologies to enhance your
                experience, maintain session security, and analyze usage
                patterns. You can control cookie preferences through your
                browser settings, though some features may not function properly
                if cookies are disabled.
              </p>
            </section>

            <section className="mb-8" data-id="element-9408" data-mp="1dx6qiwboljjx">
              <h2 className="text-xl font-bold mb-4" data-id="element-9409" data-mp="18xllc45x4eyr">
                2. How We Use Your Information
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-9410" data-mp="6kyvq3di0y0z">
                We use the collected information for the following purposes:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9411" data-mp="am0w4nj5jg4j">
                <li data-id="element-9412" data-mp="fk2gdbsbdlhl">
                  <strong data-id="element-9413" data-mp="fjja4sc10lje">Service Delivery:</strong> To provide, maintain, and
                  improve our toxicity detection and analysis services
                </li>
                <li data-id="element-9414" data-mp="p9m16mzl7pf3">
                  <strong data-id="element-9415" data-mp="pa5lgacpmpwa">AI Analysis:</strong> To process uploaded screenshots
                  using artificial intelligence to detect toxic patterns in
                  conversations
                </li>
                <li data-id="element-9416" data-mp="yc4y6qgoz7tf">
                  <strong data-id="element-9417" data-mp="y9iq8ppw2qao">Account Management:</strong> To create and manage your
                  account, authenticate your identity, and provide customer
                  support
                </li>
                <li data-id="element-9418" data-mp="351tehuolry9t">
                  <strong data-id="element-9419" data-mp="3519vsbr4p5uq">Communication:</strong> To send you service updates,
                  security alerts, and (with your consent) marketing
                  communications
                </li>
                <li data-id="element-9420" data-mp="2sr21t6qlpmwm">
                  <strong data-id="element-9421" data-mp="2sqit8gmucav9">Security:</strong> To detect, prevent, and address
                  technical issues, fraud, and security vulnerabilities
                </li>
                <li data-id="element-9422" data-mp="2itnvhzye6ei1">
                  <strong data-id="element-9423" data-mp="2iufjaolqz7xr">Analytics:</strong> To understand usage patterns,
                  improve our algorithms, and enhance user experience
                </li>
                <li data-id="element-9424" data-mp="3bi1vumcydmwr">
                  <strong data-id="element-9425" data-mp="3bhs68zvtlhrl">Legal Compliance:</strong> To comply with legal
                  obligations and enforce our Terms of Service
                </li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-9426" data-mp="32hwqsiv8f0lr">
              <h2 className="text-xl font-bold mb-4" data-id="element-9427" data-mp="32gu30jt7hea2">
                3. How We Share Your Information
              </h2>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9428" data-mp="1v1gw0rxddree">
                3.1 Third-Party Service Providers
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-9429" data-mp="3q6gkhb01e2es">
                We share information with trusted third-party service providers
                who assist in operating our platform:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9430" data-mp="3h6tgqiju4kik">
                <li data-id="element-9431" data-mp="3h8mmlvmmj0pi">
                  <strong data-id="element-9432" data-mp="3m4uz119fsfsz">Supabase:</strong> Cloud infrastructure for
                  authentication, database, and file storage
                </li>
                <li data-id="element-9433" data-mp="dqcxlie03yic">
                  <strong data-id="element-9434" data-mp="drxjkjm9294l">OpenAI:</strong> AI processing for toxicity analysis
                  (text content only, not personal identifiers)
                </li>
                <li data-id="element-9435" data-mp="3yyp4l42nod2">
                  <strong data-id="element-9436" data-mp="3xnq0ylkn4sa">Analytics Providers:</strong> For usage analytics and
                  performance monitoring (when enabled in your settings)
                </li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-9437" data-mp="wn4czgqf9th4">
                These providers are contractually obligated to protect your
                information and use it only for the specific services they
                provide to us.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9438" data-mp="16svxsd932odm">3.2 Public Sharing</h3>
              <p className="text-gray-700 mb-4" data-id="element-9439" data-mp="1kjr71qnhv7hq">
                When you choose to share analysis results using our sharing
                feature, a public link is generated that allows anyone with the
                link to view the analysis results. Shared results do not include
                your personal information but do include the analysis data and
                patterns detected.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9440" data-mp="11tsqsn9jm830">
                3.3 Legal Requirements
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-9441" data-mp="wt4zs1lbdr8s">
                We may disclose your information if required by law, court
                order, or governmental regulation, or if we believe disclosure
                is necessary to protect our rights, your safety, or the safety
                of others.
              </p>

              <h3 className="text-lg font-semibold mb-3" data-id="element-9442" data-mp="1gine676ylk1h">
                3.4 Business Transfers
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-9443" data-mp="1bmf0yzcbo0wy">
                In the event of a merger, acquisition, or sale of assets, your
                information may be transferred to the acquiring entity. We will
                notify you of any such change and provide options regarding your
                information.
              </p>
            </section>

            <section className="mb-8" data-id="element-9444" data-mp="sst05mawlpfn">
              <h2 className="text-xl font-bold mb-4" data-id="element-9445" data-mp="svxaz2ivjjfa">
                4. Data Retention and Storage
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-9446" data-mp="ivogbt4j6620">
                We retain your information for as long as necessary to provide
                our services and comply with legal obligations:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9447" data-mp="2d9xra3odpuc8">
                <li data-id="element-9448" data-mp="2d7v37p6seba5">
                  <strong data-id="element-9449" data-mp="2lqyej7ecf5yy">Account Data:</strong> Retained while your account is
                  active and for 90 days after account deletion
                </li>
                <li data-id="element-9450" data-mp="2pq7563e36nqa">
                  <strong data-id="element-9451" data-mp="2uj076ji67hyo">Uploaded Screenshots:</strong> Stored according to
                  your retention settings (30, 90, 180 days, or indefinitely)
                </li>
                <li data-id="element-9452" data-mp="2zk7hap7sct8i">
                  <strong data-id="element-9453" data-mp="22ru6a0umlg8c">Analysis Results:</strong> Retained according to your
                  chosen retention period
                </li>
                <li data-id="element-9454" data-mp="26uh0g8errd8p">
                  <strong data-id="element-9455" data-mp="26txr3g36px6a">Usage Logs:</strong> Retained for up to 12 months for
                  security and analytics purposes
                </li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-9456" data-mp="2grvfq4oyhvzf">
                You can manage your data retention preferences in the Settings
                section under Privacy Settings. You can also request deletion of
                specific scans or your entire account at any time.
              </p>
            </section>

            <section className="mb-8" data-id="element-9457" data-mp="32hbnsnx14952">
              <h2 className="text-xl font-bold mb-4" data-id="element-9458" data-mp="32kg3ahfy2rb1">5. Data Security</h2>
              <p className="text-gray-700 mb-4" data-id="element-9459" data-mp="2xja729n2slwr">
                We implement industry-standard security measures to protect your
                information:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9460" data-mp="37ir82drdubme">
                <li data-id="element-9461" data-mp="2jrlxad0au9iy">
                  <strong data-id="element-9462" data-mp="2jt6nxrjht8bj">Encryption:</strong> All data is encrypted in transit
                  (TLS/SSL) and at rest
                </li>
                <li data-id="element-9463" data-mp="2eqxxp2y08kd4">
                  <strong data-id="element-9464" data-mp="2thoms387p5cj">Authentication:</strong> Secure password hashing and
                  optional two-factor authentication (2FA)
                </li>
                <li data-id="element-9465" data-mp="2opnbokms5ko3">
                  <strong data-id="element-9466" data-mp="2opdnn2lapnl1">Access Controls:</strong> Strict access controls and
                  authentication for all data access
                </li>
                <li data-id="element-9467" data-mp="1w1hug7uxqdt0">
                  <strong data-id="element-9468" data-mp="1w21a1hx44q3v">Regular Audits:</strong> Periodic security assessments
                  and vulnerability testing
                </li>
                <li data-id="element-9469" data-mp="gayrpwyvtd3q">
                  <strong data-id="element-9470" data-mp="gbi8vbgpjxgp">Secure Infrastructure:</strong> Hosted on secure, SOC
                  2 compliant cloud infrastructure
                </li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-9471" data-mp="6lf8urb65j8v">
                While we strive to protect your information, no method of
                transmission or storage is 100% secure. We cannot guarantee
                absolute security but continuously work to improve our security
                measures.
              </p>
            </section>

            <section className="mb-8" data-id="element-9472" data-mp="l9jsbxi1pysp">
              <h2 className="text-xl font-bold mb-4" data-id="element-9473" data-mp="lco3xfxubwte">6. Your Privacy Rights</h2>
              <p className="text-gray-700 mb-4" data-id="element-9474" data-mp="pa3ph12md2eu">
                Depending on your location, you may have the following rights
                regarding your personal information:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9475" data-mp="3a3gxud8rpam9">
                <li data-id="element-9476" data-mp="3qabxgesxnk1x">
                  <strong data-id="element-9477" data-mp="3qalg1hbneoxl">Access:</strong> Request a copy of the personal
                  information we hold about you
                </li>
                <li data-id="element-9478" data-mp="3gj7llnyk0fbb">
                  <strong data-id="element-9479" data-mp="3gipj49lat4uy">Correction:</strong> Update or correct inaccurate
                  personal information
                </li>
                <li data-id="element-9480" data-mp="3bm7f5bxslajo">
                  <strong data-id="element-9481" data-mp="3bijm0dw9eq5h">Deletion:</strong> Request deletion of your personal
                  information (subject to legal retention requirements)
                </li>
                <li data-id="element-9482" data-mp="84723iddqez7">
                  <strong data-id="element-9483" data-mp="81kzlx5cipnu">Data Portability:</strong> Receive your data in a
                  structured, machine-readable format
                </li>
                <li data-id="element-9484" data-mp="3v9569tx9ymvr">
                  <strong data-id="element-9485" data-mp="3v7u05ngcx31h">Opt-Out:</strong> Opt out of marketing communications
                  and certain data processing activities
                </li>
                <li data-id="element-9486" data-mp="2jtgix1g3zluf">
                  <strong data-id="element-9487" data-mp="2js5csuz6y205">Restriction:</strong> Request restriction of
                  processing in certain circumstances
                </li>
                <li data-id="element-9488" data-mp="z92zlvzqymaa">
                  <strong data-id="element-9489" data-mp="13cr8ci047nx4">Objection:</strong> Object to processing based on
                  legitimate interests
                </li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-9490" data-mp="18aavy8ipdd1q">
                To exercise these rights, visit your Settings page or contact us
                at toxicdetector25@gmail.com. We will respond to your request
                within 30 days.
              </p>
            </section>

            <section className="mb-8" data-id="element-9491" data-mp="1mzp63iu3ryi6">
              <h2 className="text-xl font-bold mb-4" data-id="element-9492" data-mp="1n2uu0uqzwucb">
                7. International Data Transfers
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-9493" data-mp="1w1g7wclivl6r">
                Your information may be transferred to and processed in
                countries other than your country of residence. These countries
                may have different data protection laws. When we transfer your
                information internationally, we ensure appropriate safeguards
                are in place to protect your information in accordance with this
                Privacy Policy.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-9494" data-mp="101kwzohqpwuf">
                For users in the European Economic Area (EEA), we comply with
                GDPR requirements for international data transfers, including
                the use of Standard Contractual Clauses where applicable.
              </p>
            </section>

            <section className="mb-8" data-id="element-9495" data-mp="1iyc99dyv7boz">
              <h2 className="text-xl font-bold mb-4" data-id="element-9496" data-mp="1ixb05f1esz9w">8. Children's Privacy</h2>
              <p className="text-gray-700 mb-4" data-id="element-9497" data-mp="1wpqw5vvw7x1b">
                ToxicDetector is not intended for use by individuals under the
                age of 18. We do not knowingly collect personal information from
                children under 18. If we become aware that we have collected
                personal information from a child under 18, we will take steps
                to delete such information promptly.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-9498" data-mp="2lb5atiqnpgk9">
                If you are a parent or guardian and believe your child has
                provided us with personal information, please contact us at
                toxicdetector25@gmail.com.
              </p>
            </section>

            <section className="mb-8" data-id="element-9499" data-mp="2g9zl7tsam9ey">
              <h2 className="text-xl font-bold mb-4" data-id="element-9500" data-mp="2gd3rcwpbjf89">
                9. California Privacy Rights
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-9501" data-mp="27aci93jx0vjs">
                If you are a California resident, you have additional rights
                under the California Consumer Privacy Act (CCPA):
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9502" data-mp="1xk9lcs9oaxg6">
                <li data-id="element-9503" data-mp="1jl06bvx7e9ds">
                  Right to know what personal information is collected, used,
                  shared, or sold
                </li>
                <li data-id="element-9504" data-mp="1nm3nqmuwgdh4">Right to delete personal information held by businesses</li>
                <li data-id="element-9505" data-mp="24132chk98gob">
                  Right to opt-out of the sale of personal information (we do
                  not sell personal information)
                </li>
                <li data-id="element-9506" data-mp="1u3olwhybzrw0">Right to non-discrimination for exercising CCPA rights</li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-9507" data-mp="1p53xrgwcsynx">
                To exercise these rights, contact us at
                toxicdetector25@gmail.com or use the privacy controls in your
                Settings.
              </p>
            </section>

            <section className="mb-8" data-id="element-9508" data-mp="1gayzwdisymyw">
              <h2 className="text-xl font-bold mb-4" data-id="element-9509" data-mp="1bdgnue9hnrmo">
                10. European Privacy Rights (GDPR)
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-9510" data-mp="16evwz5g4mkaw">
                If you are located in the European Economic Area (EEA), you have
                rights under the General Data Protection Regulation (GDPR):
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9511" data-mp="xez4esqm91ak">
                <li data-id="element-9512" data-mp="391klcsdncpn2">
                  Legal basis for processing: Consent, contract performance,
                  legitimate interests, and legal obligations
                </li>
                <li data-id="element-9513" data-mp="3i1z5hoevjyoz">Right to withdraw consent at any time</li>
                <li data-id="element-9514" data-mp="3i2inf54iyn30">
                  Right to lodge a complaint with your local data protection
                  authority
                </li>
                <li data-id="element-9515" data-mp="2pdk5a80ejkxp">
                  Right to data portability in a structured, commonly used
                  format
                </li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-9516" data-mp="2ua26wz0fr35t">
                Our data protection officer can be reached at
                toxicdetector25@gmail.com for GDPR-related inquiries.
              </p>
            </section>

            <section className="mb-8" data-id="element-9517" data-mp="26mk84jir74tc">
              <h2 className="text-xl font-bold mb-4" data-id="element-9518" data-mp="26lizsmt4gwfb">
                11. Changes to This Privacy Policy
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-9519" data-mp="2bjstsu341qzc">
                We may update this Privacy Policy from time to time to reflect
                changes in our practices, technology, legal requirements, or
                other factors. We will notify you of any material changes by:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2" data-id="element-9520" data-mp="1ti5j6mlk464f">
                <li data-id="element-9521" data-mp="1yffegivmnc06">
                  Posting the updated Privacy Policy on this page with a new
                  "Last Updated" date
                </li>
                <li data-id="element-9522" data-mp="15rt50tzpxd5e">
                  Sending you an email notification (if you have opted in to
                  receive such notifications)
                </li>
                <li data-id="element-9523" data-mp="1apl54baio5ko">Displaying a prominent notice on our platform</li>
              </ul>
              <p className="text-gray-700 mb-4" data-id="element-9524" data-mp="1fj5w3jdozzad">
                Your continued use of ToxicDetector after any changes indicates
                your acceptance of the updated Privacy Policy.
              </p>
            </section>

            <section className="mb-8" data-id="element-9525" data-mp="myyzsrrwczed">
              <h2 className="text-xl font-bold mb-4" data-id="element-9526" data-mp="30bv0erfypcac">12. Contact Us</h2>
              <p className="text-gray-700 mb-4" data-id="element-9527" data-mp="2w9zx5heh0otx">
                If you have questions, concerns, or requests regarding this
                Privacy Policy or our privacy practices, please contact us:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-9528" data-mp="2mcbve7ig6h29">
                <p className="text-gray-700 mb-2" data-id="element-9529" data-mp="2mdwqby8oc20n">
                  <strong data-id="element-9530" data-mp="2hdr26s1m4xnb">Email:</strong> toxicdetector25@gmail.com
                </p>
                <p className="text-gray-700 mb-2" data-id="element-9531" data-mp="2clh8d0xdndfr">
                  <strong data-id="element-9532" data-mp="2cjw94y04b6bk">Support:</strong> support@toxicdetector.com
                </p>
                <p className="text-gray-700" data-id="element-9533" data-mp="28knhbyon1iin">
                  <strong data-id="element-9534" data-mp="23lkjay72sck6">Data Protection Officer:</strong>{' '}
                  toxicdetector25@gmail.com
                </p>
              </div>
            </section>

            <section className="mb-8" data-id="element-9535" data-mp="1yoc5tawvgwp9">
              <h2 className="text-xl font-bold mb-4" data-id="element-9536" data-mp="1tmmstpq3a8yj">13. Consent</h2>
              <p className="text-gray-700 mb-4" data-id="element-9537" data-mp="1tphchf1a3pqw">
                By using ToxicDetector, you consent to our Privacy Policy and
                agree to its terms. If you do not agree with this Privacy
                Policy, please discontinue use of our services immediately.
              </p>
            </section>

            <div className="border-t border-gray-200 pt-6 mt-8" data-id="element-9538" data-mp="1f063h80ksmzn">
              <p className="text-gray-600 text-sm text-center" data-id="element-9539" data-mp="1f2im7ne5r1dr">
                © {new Date().getFullYear()} ToxicDetector. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>;
}